import { ReactElement } from 'react';
import { Stack, Typography, Link } from '@mui/material';

import { DashboardVariantV2CarrierStatusItemsListProps } from './types';

const DashboardVariantV2CarrierStatusItemsList = ({
  items,
}: DashboardVariantV2CarrierStatusItemsListProps): ReactElement => (
  <Stack spacing={0.7}>
    {items.map((item, itemIndex) => (
      <Stack
        key={`status-items-list-item-${itemIndex}`}
        spacing={1}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack spacing={2} direction="row" alignItems="center">
          {item.icon}

          <Link
            variant="body2"
            color="text.secondary"
            fontWeight={item.labelBold ? 'bold' : 'regular'}
            underline="hover"
            onClick={item.onClick}
            sx={{ cursor: 'pointer' }}
          >
            {item.label}
          </Link>
        </Stack>

        <Typography variant="body2" fontWeight="bold">
          {item.value}
        </Typography>
      </Stack>
    ))}
  </Stack>
);

export default DashboardVariantV2CarrierStatusItemsList;
